/**
 * @author Naveen Muthusamy <naveen@wordlift.io>
 * @since 3.32.6
 * Actions types fired on the no editor analysis.
 */

export const NO_EDITOR_SYNC_FORM_DATA = 'NO_EDITOR_SYNC_FORM_DATA'

export const ANALYSIS_RUNNING = 'ANALYSIS_RUNNING'

export const ANALYSIS_COMPLETE = 'ANALYSIS_COMPLETE'